import { TicketsMapAssignments } from './TicketsMapAssignments';
// in src/posts.js
import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, TextInput, Button, TopToolbar, required, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, SaveButton, useUpdate, useNotify, FileInput, FileField, FunctionField, useDataProvider } from 'react-admin';import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';



import EditIcon from '@material-ui/icons/Edit';
import Grid from '@mui/material/Grid';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RefreshIcon from '@mui/icons-material/Refresh';
import FileCopyIcon from '@material-ui/icons/FileCopy';

import Box from '@material-ui/core/Box';


import { validateMaxLength } from './../components/Validator';import {apiUrl, maxDocSvgSize} from './../common/constants';
import { headersAPIObjectAuth } from './../common/utils';

const SEAT_STATUS_AVAILABLE_EVERYONE = 0;
const SEAT_STATUS_BLOCKED = 1;
const SEAT_STATUS_AVAILABLE_ONLY_BOX_OFFICE = 2;
const SEAT_STATUS_BASKET = 3;
const SEAT_STATUS_PENDING_PAYMENT = 4;
const SEAT_STATUS_RESERVED = 5;
const SEAT_STATUS_PURCHASED = 6;
const SEAT_STATUS_INVITATION = 7;

const seatStatusColor = status => {
  if (Number(status) === SEAT_STATUS_AVAILABLE_ONLY_BOX_OFFICE) return '#f59e0b';
  if (Number(status) === SEAT_STATUS_BLOCKED) return '#ff0000';
  if (Number(status) === SEAT_STATUS_BASKET) return '#3b82f6';
  if (Number(status) === SEAT_STATUS_PENDING_PAYMENT) return '#facc15';
  if (Number(status) === SEAT_STATUS_RESERVED) return '#d1d5db';
  if (Number(status) === SEAT_STATUS_INVITATION) return '#4b5563';
  if (Number(status) === SEAT_STATUS_PURCHASED) return '#000000';
  return '#22c55e';
};

const seatStatusTranslation = status => {
  if (Number(status) === SEAT_STATUS_AVAILABLE_ONLY_BOX_OFFICE) return 'tickets_maps.status_available_only_box_office';
  if (Number(status) === SEAT_STATUS_BLOCKED) return 'tickets_maps.status_blocked';
  if (Number(status) === SEAT_STATUS_BASKET) return 'tickets_maps.status_basket';
  if (Number(status) === SEAT_STATUS_PENDING_PAYMENT) return 'tickets_maps.status_pending_payment';
  if (Number(status) === SEAT_STATUS_RESERVED) return 'tickets_maps.status_reserved';
  if (Number(status) === SEAT_STATUS_INVITATION) return 'tickets_maps.status_invitation';
  if (Number(status) === SEAT_STATUS_PURCHASED) return 'tickets_maps.status_purchased';
  return 'tickets_maps.status_available_everyone';
};

const seatStatusSvgValue = status => {
  if (Number(status) === SEAT_STATUS_AVAILABLE_ONLY_BOX_OFFICE) return 'AVAILABLE_ONLY_BOX_OFFICE';
  if (Number(status) === SEAT_STATUS_BLOCKED) return 'BLOCKED';
  return 'AVAILABLE_EVERYONE';
};

const generateUpdatedMapSvg = (svgText, zones) => {
  const documentSvg = new DOMParser().parseFromString(svgText, 'image/svg+xml');
  if (documentSvg.querySelector('parsererror')) throw new Error('No s\'ha pogut generar l\'SVG');

  const elementsBySvgId = new Map();
  documentSvg.querySelectorAll('[id]').forEach(element => elementsBySvgId.set(element.id, element));

  zones.forEach(zone => {
    const zoneElement = elementsBySvgId.get(zone.svg_id);
    if (zoneElement) {
      zoneElement.setAttribute('data-type', Number(zone.type) === 0 ? 'SEATS' : 'STANDING');
      if (zone.name != null) zoneElement.setAttribute('data-name', zone.name);
      if (zone.gate != null) zoneElement.setAttribute('data-access', zone.gate);
      if (Number(zone.type) !== 0) {
        zoneElement.setAttribute('data-capacity', String(zone.capacity || 0));
        zoneElement.removeAttribute('data-default-blocked');
      }
    }

    (zone.seats || []).forEach(seat => {
      const seatElement = elementsBySvgId.get(seat.svg_id);
      if (seatElement) seatElement.setAttribute('data-default-status', seatStatusSvgValue(
        seat.configured_status == null ? seat.default_status : seat.configured_status
      ));
    });
  });

  return `<?xml version="1.0" encoding="UTF-8"?>\n${new XMLSerializer().serializeToString(documentSvg.documentElement)}`;
};

const getAllMapRecords = async (dataProvider, resource, filter) => {
  const perPage = 1000;
  let page = 1;
  let records = [];
  let total = 0;

  do {
    const result = await dataProvider.getList(resource, {
      pagination: { page, perPage },
      sort: { field: 'id', order: 'ASC' },
      filter
    });
    records = records.concat(result.data);
    total = result.total;
    if (result.data.length === 0) break;
    page += 1;
  } while (records.length < total);

  return records;
};

const getSessionMapStats = zones => {
  const counts = {
    [SEAT_STATUS_AVAILABLE_EVERYONE]: 0,
    [SEAT_STATUS_BLOCKED]: 0,
    [SEAT_STATUS_AVAILABLE_ONLY_BOX_OFFICE]: 0,
    [SEAT_STATUS_BASKET]: 0,
    [SEAT_STATUS_PENDING_PAYMENT]: 0,
    [SEAT_STATUS_RESERVED]: 0,
    [SEAT_STATUS_INVITATION]: 0,
    [SEAT_STATUS_PURCHASED]: 0
  };

  zones.forEach(zone => {
    if (Number(zone.type) === 0) {
      (zone.seats || []).forEach(seat => {
        const status = Number(seat.status);
        counts[status] = (counts[status] || 0) + 1;
      });
      return;
    }

    const capacity = Number(zone.capacity || 0);
    const basket = Number(zone.basket_count || 0);
    const pendingPayment = Number(zone.pending_payment_count || 0);
    const reserved = Number(zone.reserved_count || 0);
    const invitation = Number(zone.invitation_count || 0);
    const purchased = Number(zone.purchased_count || 0);
    const occupied = basket + pendingPayment + reserved + invitation + purchased;

    counts[SEAT_STATUS_AVAILABLE_EVERYONE] += Math.max(capacity - occupied, 0);
    counts[SEAT_STATUS_BASKET] += basket;
    counts[SEAT_STATUS_PENDING_PAYMENT] += pendingPayment;
    counts[SEAT_STATUS_RESERVED] += reserved;
    counts[SEAT_STATUS_INVITATION] += invitation;
    counts[SEAT_STATUS_PURCHASED] += purchased;
  });

  return {
    counts,
    total: Object.entries(counts).reduce((total, [status, count]) =>
      Number(status) === SEAT_STATUS_BLOCKED ? total : total + count, 0)
  };
};

const TicketsMapInteractiveSvg = ({ svgText, zones, savingSeatIds, savingZoneIds, onSeatClick, onZoneClick, sessionMode = false }) => {
  const translate = useTranslate();
  const containerRef = React.useRef(null);
  const [tooltip, setTooltip] = useState(null);

  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const elementsBySvgId = new Map();
    container.querySelectorAll('[id]').forEach(element => elementsBySvgId.set(element.id, element));

    zones.forEach(zone => {
      const zoneElement = elementsBySvgId.get(zone.svg_id);
      const seats = zone.seats || [];
      const statusOf = seat => sessionMode ? Number(seat.status) : Number(seat.default_status || 0);
      const availableEveryone = seats.filter(seat => statusOf(seat) === SEAT_STATUS_AVAILABLE_EVERYONE).length;
      const availableOnlyBoxOffice = seats.filter(seat => statusOf(seat) === SEAT_STATUS_AVAILABLE_ONLY_BOX_OFFICE).length;
      const blocked = seats.filter(seat => statusOf(seat) === SEAT_STATUS_BLOCKED).length;

      if (zoneElement) {
        const isNumberedZone = Number(zone.type) === 0;
        zoneElement.setAttribute('data-map-zone-id', String(zone.id));
        zoneElement.setAttribute(
          'data-map-tooltip',
          isNumberedZone
            ? `${zone.name}: ${translate('tickets_maps.status_available_everyone')} ${availableEveryone}, ` +
              `${translate('tickets_maps.status_available_only_box_office')} ${availableOnlyBoxOffice}, ` +
              `${translate('tickets_maps.status_blocked')} ${blocked}`
            : sessionMode
              ? `${zone.name}: ${translate('tickets_zones.available_capacity')} ${Number(zone.capacity || 0)}, ` +
                `${translate('tickets_maps.status_basket')} ${Number(zone.basket_count || 0)}, ` +
                `${translate('tickets_maps.status_pending_payment')} ${Number(zone.pending_payment_count || 0)}, ` +
                `${translate('tickets_maps.status_reserved')} ${Number(zone.reserved_count || 0)}, ` +
                `${translate('tickets_maps.status_invitation')} ${Number(zone.invitation_count || 0)}, ` +
                `${translate('tickets_maps.status_purchased')} ${Number(zone.purchased_count || 0)}`
              : `${zone.name}: ${translate('tickets_zones.available_capacity')} ${Number(zone.capacity || 0)}`
        );

        const zoneBase = zoneElement.querySelector('.zone-base');
        if (zoneBase && !isNumberedZone) {
          const zoneStatus = Number(zone.capacity) > 0 ? SEAT_STATUS_AVAILABLE_EVERYONE : SEAT_STATUS_BLOCKED;
          zoneBase.style.setProperty('fill', seatStatusColor(zoneStatus), 'important');
          zoneBase.style.setProperty('fill-opacity', '0.3', 'important');
          zoneBase.style.setProperty('cursor', savingZoneIds.includes(zone.id) ? 'wait' : 'pointer', 'important');
          zoneBase.style.setProperty('opacity', savingZoneIds.includes(zone.id) ? '0.55' : '1', 'important');
          zoneBase.style.setProperty('pointer-events', 'visiblePainted', 'important');
        }
      }

      seats.forEach(seat => {
        const seatElement = elementsBySvgId.get(seat.svg_id);
        if (!seatElement) return;

        const status = sessionMode
          ? Number(seat.status)
          : seat.default_status == null ? SEAT_STATUS_AVAILABLE_EVERYONE : Number(seat.default_status);
        const seatLabel = [
          zone.name,
          seat.row ? `${translate('tickets_seats.row')}: ${seat.row}` : null,
          seat.number ? `${translate('tickets_seats.seat')}: ${seat.number}` : null,
          translate(seatStatusTranslation(status))
        ].filter(Boolean).join(' · ');

        seatElement.setAttribute('data-map-seat-id', String(seat.id));
        seatElement.setAttribute('data-map-tooltip', seatLabel);
        seatElement.style.setProperty('fill', seatStatusColor(status), 'important');
        seatElement.style.setProperty('stroke', '#ffffff', 'important');
        const editable = !sessionMode || seat.editable !== false;
        seatElement.style.setProperty('cursor', savingSeatIds.includes(seat.id) ? 'wait' : editable ? 'pointer' : 'not-allowed', 'important');
        seatElement.style.setProperty('opacity', savingSeatIds.includes(seat.id) ? '0.55' : '1', 'important');
        seatElement.style.setProperty('pointer-events', 'visiblePainted', 'important');
      });
    });

    setTooltip(currentTooltip => {
      if (!currentTooltip || !currentTooltip.element || !currentTooltip.element.isConnected) return currentTooltip;
      const updatedText = currentTooltip.element.getAttribute('data-map-tooltip');
      return updatedText === currentTooltip.text ? currentTooltip : { ...currentTooltip, text: updatedText };
    });
  }, [savingSeatIds, savingZoneIds, sessionMode, translate, zones]);

  const handleMouseMove = event => {
    const item = event.target.closest && event.target.closest('[data-map-seat-id], [data-map-zone-id]');
    if (!item || !containerRef.current) {
      setTooltip(null);
      return;
    }
    const bounds = containerRef.current.getBoundingClientRect();
    setTooltip({
      element: item,
      text: item.getAttribute('data-map-tooltip'),
      x: event.clientX - bounds.left + containerRef.current.scrollLeft + 12,
      y: event.clientY - bounds.top + containerRef.current.scrollTop + 12
    });
  };

  const handleClick = event => {
    const seatElement = event.target.closest && event.target.closest('[data-map-seat-id]');
    if (seatElement) {
      event.stopPropagation();
      const seatId = Number(seatElement.getAttribute('data-map-seat-id'));
      const seat = zones.reduce((found, zone) => found || (zone.seats || []).find(item => item.id === seatId), null);
      if (!sessionMode || !seat || seat.editable !== false) onSeatClick(seatId);
      return;
    }

    const zoneElement = event.target.closest && event.target.closest('[data-map-zone-id]');
    if (zoneElement) {
      event.stopPropagation();
      onZoneClick(Number(zoneElement.getAttribute('data-map-zone-id')));
    }
  };

  return (
    <div
      ref={containerRef}
      className="tickets-maps-editor"
      onMouseMove={handleMouseMove}
      onMouseLeave={() => setTooltip(null)}
      onClick={handleClick}
    >
      <div className="tickets-maps-editor-svg" dangerouslySetInnerHTML={{ __html: svgText }} />
      {tooltip && <div className="tickets-maps-editor-tooltip" style={{ left: tooltip.x, top: tooltip.y }}>{tooltip.text}</div>}
    </div>
  );
};

const sessionMapRequest = async (sessionId, options = {}) => {
  const response = await fetch(`${apiUrl}/events_sessions/${sessionId}/map-status`, {
    ...options,
    headers: { ...headersAPIObjectAuth(), ...(options.headers || {}) }
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || body.error || response.statusText);
  return body;
};

const TicketsMapsSettingsSvgImage = ({ documentUrl, mapId, sessionId, title, editable = false }) => {
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [imageUrl, setImageUrl] = useState(null);
  const [svgText, setSvgText] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [zones, setZones] = useState([]);
  const [loadingMap, setLoadingMap] = useState(false);
  const [mapDataLoaded, setMapDataLoaded] = useState(false);
  const [savingSeatIds, setSavingSeatIds] = useState([]);
  const [savingZoneIds, setSavingZoneIds] = useState([]);
  const [capacityDialogZone, setCapacityDialogZone] = useState(null);
  const [mapRefreshVersion, setMapRefreshVersion] = useState(0);
  const hasChangesRef = React.useRef(false);
  const sessionMapStats = React.useMemo(() => getSessionMapStats(zones), [zones]);
  const sessionLegendStatuses = [
    SEAT_STATUS_AVAILABLE_EVERYONE,
    SEAT_STATUS_AVAILABLE_ONLY_BOX_OFFICE,
    SEAT_STATUS_BASKET,
    SEAT_STATUS_PENDING_PAYMENT,
    SEAT_STATUS_RESERVED,
    SEAT_STATUS_INVITATION,
    SEAT_STATUS_PURCHASED,
    SEAT_STATUS_BLOCKED
  ];
  const formatSessionPercentage = count => sessionMapStats.total > 0
    ? `${new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format((count * 100) / sessionMapStats.total)}%`
    : '0%';

  React.useEffect(() => {
    if (!documentUrl) {
      setImageUrl(null);
      setSvgText(null);
      return;
    }

    let mounted = true;
    let objectUrl = null;
    const headers = headersAPIObjectAuth();
    delete headers.Accept;
    delete headers['Content-Type'];

    fetch(documentUrl, { headers })
      .then(response => response.ok ? response.text() : null)
      .then(svgText => {
        if (!mounted || !svgText) return;
        objectUrl = URL.createObjectURL(new Blob([svgText], { type: 'image/svg+xml' }));
        setSvgText(svgText);
        setImageUrl(objectUrl);
      })
      .catch(() => {
        if (mounted) {
          setImageUrl(null);
          setSvgText(null);
        }
      });

    return () => {
      mounted = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [documentUrl]);

  React.useEffect(() => {
    if (!showDialog || !editable || !mapId) return undefined;

    let mounted = true;
    setLoadingMap(true);
    setMapDataLoaded(false);
    const mapDataPromise = sessionId
      ? sessionMapRequest(sessionId).then(data => data.zones || [])
      : getAllMapRecords(dataProvider, 'tickets_zones', { tickets_maps_id: mapId })
      .then(async data => {
        const zonesWithSeats = await Promise.all(data.map(async zone => {
          if (Number(zone.type) !== 0) return { ...zone, seats: [] };
          const seats = await getAllMapRecords(dataProvider, 'tickets_seats', { tickets_zones_id: zone.id });
          return { ...zone, seats };
        }));
        return zonesWithSeats;
      });

    mapDataPromise
      .then(data => {
        if (mounted) {
          setZones(data);
          setMapDataLoaded(true);
        }
      })
      .catch(error => {
        if (mounted) {
          setZones([]);
          notify(error.message, 'error');
        }
      })
      .finally(() => {
        if (mounted) setLoadingMap(false);
      });

    return () => { mounted = false; };
  }, [dataProvider, editable, mapId, mapRefreshVersion, notify, sessionId, showDialog]);

  const handleSeatClick = async seatId => {
    if (savingSeatIds.includes(seatId)) return;
    const currentSeat = zones.reduce((found, zone) => found || (zone.seats || []).find(seat => seat.id === seatId), null);
    if (sessionId && (!currentSeat || currentSeat.editable === false)) return;
    setSavingSeatIds(ids => [...ids, seatId]);
    try {
      if (sessionId) {
        const currentStatus = Number(currentSeat.configured_status || 0);
        const status = currentStatus === SEAT_STATUS_AVAILABLE_EVERYONE
          ? SEAT_STATUS_BLOCKED
          : currentStatus === SEAT_STATUS_BLOCKED
            ? SEAT_STATUS_AVAILABLE_ONLY_BOX_OFFICE
            : SEAT_STATUS_AVAILABLE_EVERYONE;
        const data = await sessionMapRequest(sessionId, {
          method: 'PUT',
          body: JSON.stringify({ tickets_seats_id: seatId, status })
        });
        setZones(data.zones || []);
      } else {
        const { data } = await dataProvider.create(`tickets_seats/${seatId}/cycle-default-status`, { data: {} });
        setZones(currentZones => currentZones.map(zone => ({
          ...zone,
          seats: (zone.seats || []).map(seat => seat.id === seatId ? { ...seat, default_status: data.default_status } : seat)
        })));
      }
      hasChangesRef.current = true;
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setSavingSeatIds(ids => ids.filter(id => id !== seatId));
    }
  };

  const handleZoneClick = zoneId => {
    const zone = zones.find(item => item.id === zoneId);
    if (!zone || Number(zone.type) === 0 || savingZoneIds.includes(zoneId)) return;
    setCapacityDialogZone(zone);
  };

  const handleCapacitySubmit = async values => {
    if (!capacityDialogZone) return;
    const capacity = Number(values.capacity);
    const minimumCapacity = sessionId ? Number(capacityDialogZone.occupied_count || 0) + 1 : 0;
    if (!Number.isInteger(capacity) || capacity < minimumCapacity) {
      notify(sessionId
        ? translate('tickets_maps.capacity_above_occupied', { occupied: capacityDialogZone.occupied_count || 0 })
        : translate('common.validation.number'), 'warning');
      return;
    }

    const zoneId = capacityDialogZone.id;
    setSavingZoneIds(ids => [...ids, zoneId]);
    try {
      if (sessionId) {
        const data = await sessionMapRequest(sessionId, {
          method: 'PUT',
          body: JSON.stringify({ tickets_zones_id: zoneId, capacity })
        });
        setZones(data.zones || []);
      } else {
        await dataProvider.update('tickets_zones', {
          id: zoneId,
          data: {
            tickets_maps_id: capacityDialogZone.tickets_maps_id,
            name: capacityDialogZone.name,
            access: capacityDialogZone.gate,
            capacity
          },
          previousData: capacityDialogZone
        });
        setZones(currentZones => currentZones.map(zone => zone.id === zoneId
          ? { ...zone, capacity, sale_capacity: capacity }
          : zone));
      }
      setCapacityDialogZone(null);
      hasChangesRef.current = true;
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setSavingZoneIds(ids => ids.filter(id => id !== zoneId));
    }
  };

  const handleDialogOpen = event => {
    event.stopPropagation();
    hasChangesRef.current = false;
    setShowDialog(true);
  };

  const handleDialogClose = event => {
    if (event) event.stopPropagation();
    setShowDialog(false);
    if (hasChangesRef.current) {
      hasChangesRef.current = false;
      refresh();
    }
  };

  const handleDownloadSvg = event => {
    event.stopPropagation();
    try {
      const downloadContent = editable ? generateUpdatedMapSvg(svgText, zones) : svgText;
      const downloadUrl = URL.createObjectURL(new Blob([downloadContent], { type: 'image/svg+xml;charset=utf-8' }));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `${title || 'map'}.svg`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(downloadUrl), 0);
    } catch (error) {
      notify(error.message, 'error');
    }
  };

  if (!imageUrl) {
    return null;
  }

  return (
    <>
      <Tooltip title={translate('tickets_maps.preview')}>
        <button type="button" className="tickets-maps-settings-svg-preview-button" aria-label={translate('tickets_maps.preview')} onClick={handleDialogOpen} onMouseDown={event => event.stopPropagation()}>
          <img src={imageUrl} className="tickets-maps-settings-svg-preview" alt={title} />
        </button>
      </Tooltip>
      <Dialog open={showDialog} onClose={handleDialogClose} onClick={event => event.stopPropagation()} maxWidth={sessionId ? 'xl' : 'lg'} fullWidth>
        <DialogTitle className="tickets-maps-settings-svg-preview-dialog-title">
          {title}
          {sessionId && (
            <IconButton
              className="tickets-maps-settings-svg-preview-dialog-refresh"
              disabled={loadingMap}
              aria-label={translate('ra.action.refresh')}
              title={translate('ra.action.refresh')}
              onClick={() => setMapRefreshVersion(version => version + 1)}
            >
              <RefreshIcon />
            </IconButton>
          )}
          <IconButton
            className="tickets-maps-settings-svg-preview-dialog-download"
            disabled={!svgText || (editable && !mapDataLoaded)}
            aria-label={translate('tickets_maps.download_svg')}
            onClick={handleDownloadSvg}
          >
            <FileDownloadIcon />
          </IconButton>
          <IconButton className="tickets-maps-settings-svg-preview-dialog-close" onClick={handleDialogClose} aria-label={translate('ra.action.close')}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={sessionId ? 'tickets-maps-editor-dialog-content' : undefined}>
          {editable && !sessionId && (
            <div className="tickets-maps-editor-legend">
              <span><i style={{ backgroundColor: seatStatusColor(SEAT_STATUS_AVAILABLE_EVERYONE) }} />{translate('tickets_maps.status_available_everyone')}</span>
              <span><i style={{ backgroundColor: seatStatusColor(SEAT_STATUS_AVAILABLE_ONLY_BOX_OFFICE) }} />{translate('tickets_maps.status_available_only_box_office')}</span>
              <span><i style={{ backgroundColor: seatStatusColor(SEAT_STATUS_BLOCKED) }} />{translate('tickets_maps.status_blocked')}</span>
            </div>
          )}
          <div className={sessionId ? 'tickets-maps-editor-layout' : undefined}>
            <div className={sessionId ? 'tickets-maps-editor-map-column' : undefined}>
              {editable && loadingMap && <div className="tickets-maps-editor-loading">{translate('ra.page.loading')}</div>}
              {editable && !loadingMap && svgText
                ? <TicketsMapInteractiveSvg
                    svgText={svgText}
                    zones={zones}
                    savingSeatIds={savingSeatIds}
                    savingZoneIds={savingZoneIds}
                    onSeatClick={handleSeatClick}
                    onZoneClick={handleZoneClick}
                    sessionMode={Boolean(sessionId)}
                  />
                : !editable && <img src={imageUrl} className="tickets-maps-settings-svg-preview-large" title={title} alt={title} />}
            </div>
            {editable && sessionId && (
              <div className="tickets-maps-editor-legend tickets-maps-editor-legend-side">
                <div className="tickets-maps-editor-legend-total">
                  <span>{translate('tickets_maps.total_on_sale')}</span>
                  <strong>{sessionMapStats.total}</strong>
                </div>
                {sessionLegendStatuses.map(status => {
                  const count = sessionMapStats.counts[status] || 0;
                  return (
                    <span
                      key={status}
                      className={status === SEAT_STATUS_BLOCKED ? 'tickets-maps-editor-legend-blocked' : undefined}
                    >
                      <i style={{ backgroundColor: seatStatusColor(status) }} />
                      <span className="tickets-maps-editor-legend-label">{translate(seatStatusTranslation(status))}</span>
                      <strong>{count}{status !== SEAT_STATUS_BLOCKED && ` (${formatSessionPercentage(count)})`}</strong>
                    </span>
                  );
                })}
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={Boolean(capacityDialogZone)}
        onClose={() => setCapacityDialogZone(null)}
        onClick={event => event.stopPropagation()}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>{translate('tickets_zones.edit_available_capacity')}</DialogTitle>
        {capacityDialogZone && (
          <FormWithRedirect
            key={`standing-zone-capacity-${capacityDialogZone.id}`}
            resource="tickets_zones"
            save={handleCapacitySubmit}
            initialValues={{ capacity: capacityDialogZone.capacity || 0 }}
            render={({ handleSubmitWithRedirect, pristine, saving }) => (
              <>
                <DialogContent>
                  {sessionId && (
                    <div className="tickets-maps-zone-occupancy">
                      <Typography>{translate('tickets_maps.status_basket')}: {Number(capacityDialogZone.basket_count || 0)}</Typography>
                      <Typography>{translate('tickets_maps.status_pending_payment')}: {Number(capacityDialogZone.pending_payment_count || 0)}</Typography>
                      <Typography>{translate('tickets_maps.status_reserved')}: {Number(capacityDialogZone.reserved_count || 0)}</Typography>
                      <Typography>{translate('tickets_maps.status_invitation')}: {Number(capacityDialogZone.invitation_count || 0)}</Typography>
                      <Typography>{translate('tickets_maps.status_purchased')}: {Number(capacityDialogZone.purchased_count || 0)}</Typography>
                      <Typography>{translate('tickets_maps.occupied_total')}: {Number(capacityDialogZone.occupied_count || 0)}</Typography>
                    </div>
                  )}
                  <TextInput
                    autoFocus
                    fullWidth
                    type="number"
                    source="capacity"
                    label={translate('tickets_zones.available_capacity')}
                    inputProps={{ min: sessionId ? Number(capacityDialogZone.occupied_count || 0) + 1 : 0, step: 1 }}
                    validate={required()}
                  />
                </DialogContent>
                <DialogActions>
                  <Button label="ra.action.cancel" onClick={() => setCapacityDialogZone(null)} />
                  <SaveButton
                    handleSubmitWithRedirect={handleSubmitWithRedirect}
                    pristine={pristine}
                    saving={saving || savingZoneIds.includes(capacityDialogZone.id)}
                  />
                </DialogActions>
              </>
            )}
          />
        )}
      </Dialog>
    </>
  );
};

export const TicketsMapSvgPreview = ({ mapId, sessionId, title, editable = false }) => {
  const dataProvider = useDataProvider();
  const [documentUrl, setDocumentUrl] = useState(null);

  React.useEffect(() => {
    if (!mapId) {
      setDocumentUrl(null);
      return;
    }

    let mounted = true;
    dataProvider.getList('docs', {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'id', order: 'ASC' },
      filter: { target: 56, items_id: mapId }
    })
      .then(({ data }) => {
        if (!mounted) return;
        const svgDoc = data.find(item => item && (
          item.mimeType === 'image/svg+xml' ||
          (item.name && item.name.toLowerCase().endsWith('.svg'))
        ));
        setDocumentUrl(svgDoc ? svgDoc.url : null);
      })
      .catch(() => {
        if (mounted) setDocumentUrl(null);
      });

    return () => {
      mounted = false;
    };
  }, [dataProvider, mapId]);

  if (!documentUrl) {
    return null;
  }

  return <TicketsMapsSettingsSvgImage documentUrl={documentUrl} mapId={mapId} sessionId={sessionId} title={title} editable={editable} />;
};

const TicketsMapsSettingsZonesTotal = ({ record }) => {
  return record && record.total_capacity != null ? record.total_capacity : null;
};

const TicketsMapsSettingsZonesExpand = ({ record }) => {
  const dataProvider = useDataProvider();
  const translate = useTranslate();
  const [zones, setZones] = useState([]);

  React.useEffect(() => {
    if (!record || !record.id) {
      setZones([]);
      return;
    }

    let mounted = true;
    dataProvider.getList('tickets_zones', {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'id', order: 'ASC' },
      filter: { tickets_maps_id: record.id, no_pagination: true }
    })
      .then(({ data }) => {
        if (mounted) setZones(data);
      })
      .catch(() => {
        if (mounted) setZones([]);
      });

    return () => {
      mounted = false;
    };
  }, [dataProvider, record && record.id]);

  return (
    <div className="tickets-maps-settings-zones-expand">
      <table className="tickets-maps-settings-zones-table">
        <thead>
          <tr>
            <th>{translate('tickets_zones.name')}</th>
            <th>{translate('tickets_zones.numbered_seats')}</th>
            <th>{translate('tickets_zones.available_everyone_capacity')}</th>
            <th>{translate('tickets_zones.available_only_box_office_capacity')}</th>
            <th>{translate('tickets_zones.blocked_capacity')}</th>
          </tr>
        </thead>
        <tbody>
          {zones.map(zone => (
            <tr key={zone.id}>
              <td>{zone.name}</td>
              <td>{zone.type === 0 ? translate('common.yes') : translate('common.no')}</td>
              <td>{zone.type === 0 ? zone.available_everyone_capacity : zone.sale_capacity}</td>
              <td>{zone.type === 0 ? zone.available_only_box_office_capacity : null}</td>
              <td>{zone.type === 0 ? zone.blocked_capacity : null}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const SettingsTicketsMaps = (props) => {
  const translate = useTranslate();    
    
  return (
    <>
      <br/>
      <Typography variant="h5" className="grey8" align="center">
        {translate('tickets_maps.title')}              
      </Typography>
      <Box sx={{ bgcolor: 'background.paper', padding: '20px' }} className="settings_box" >
        <ResourceContextProvider value="tickets_maps">
          <List {...props} 
            basePath="/tickets_maps" 
            sort={{ field: 'id', order: 'ASC' }} 
            actions={<ListActionsTicketsMapsList/>}    
            filter={{ associations_id : localStorage.getItem('associations_id') }}  
            bulkActionButtons={false}  
            perPage={1000}
            pagination={false}
            empty={<ListActionsTicketsMapsList />} 
            fullWidth
          >        
            <Datagrid fullWidth expand={<TicketsMapsSettingsZonesExpand />}>            
              <FunctionField source="id" label={translate('tickets_maps.preview')} sortable={false} render={record => <TicketsMapSvgPreview mapId={record.id} title={record.name} editable />} />
              <TextField source="name" label={translate('tickets_maps.name')} sortable={false} />
              <TicketsMapAssignments label={translate('tickets_maps.sessions_assigned')} sortable={false} />
              <FunctionField source="id" label={translate('tickets_maps.total_capacity')} sortable={false} render={record => <TicketsMapsSettingsZonesTotal record={record} />} />
              <TicketsMapsDuplicateButton />
              <TicketsMapsEditButton label="" />
              <TicketsMapsDeleteButton />
            </Datagrid>        
          </List>
        </ResourceContextProvider>
      </Box>
    </>
  );
};

const TicketsMapsDeleteButton = props => {
  const notify = useNotify();
  const translate = useTranslate();
  const stopPropagation = event => event.stopPropagation();
  const onFailure = error => notify(error.message, 'error');

  return (
    <span onClick={stopPropagation} onMouseDown={stopPropagation} onPointerDown={stopPropagation}>
      <Tooltip title={translate('ra.action.delete')}>
        <span>
          <DeleteButton {...props} label="" title={translate('ra.action.delete')} aria-label={translate('ra.action.delete')} undoable={false} redirect={false} onFailure={onFailure} />
        </span>
      </Tooltip>
    </span>
  );
};

const TicketsMapsDuplicateButton = ({ record }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();
  const stopPropagation = event => event.stopPropagation();

  const handleSubmit = async values => {
    setLoading(true);
    try {
      await dataProvider.create(`tickets_maps/${record.id}/duplicate`, { data: { name: values.name } });
      setShowDialog(false);
      refresh();
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <span onClick={stopPropagation} onMouseDown={stopPropagation} onPointerDown={stopPropagation}>
      <Tooltip title={translate('tickets_maps.duplicate')}>
        <span>
          <Button
            label=""
            startIcon={<FileCopyIcon />}
            title={translate('tickets_maps.duplicate')}
            aria-label={translate('tickets_maps.duplicate')}
            onClick={() => setShowDialog(true)}
          />
        </span>
      </Tooltip>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-label={translate('tickets_maps.duplicate')}
        className="dialog-md"
        maxWidth="sm"
      >
        <DialogTitle>{translate('tickets_maps.duplicate')}</DialogTitle>
        <FormWithRedirect
          key={showDialog ? `duplicate-map-${record.id}` : 'duplicate-map-closed'}
          resource="tickets_maps"
          save={handleSubmit}
          initialValues={{ name: '' }}
          render={({ handleSubmitWithRedirect, pristine, saving }) => (
            <>
              <DialogContent>
                <TextInput
                  autoFocus
                  fullWidth
                  source="name"
                  label={translate('tickets_maps.name')}
                  validate={[required(), validateMaxLength(255, translate('common.validation.maxLength'))]}
                />
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={() => setShowDialog(false)} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton
                  label={translate('tickets_maps.duplicate')}
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </span>
  );
};
const ListActionsTicketsMapsList = (props) => {
  const translate = useTranslate(); 
  return (
    <TopToolbar>     
      <TicketsMapsCreateButton />      
    </TopToolbar>
  );
};


const TicketsMapsCreateButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
    
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [create, { loading }] = useCreate('tickets_maps');

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };    

  return (
    <>            
      <Button onClick={handleClick} label={translate('tickets_maps.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('tickets_maps.create')}
        className="dialog-md"
        maxWidth="lg"
      >
        <DialogTitle>{translate('tickets_maps.create')}</DialogTitle>

        <FormWithRedirect
          resource="tickets_maps"
          save={handleSubmit}
          initialValues={ { associations_id : localStorage.getItem('associations_id') } }
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <FormContent create={true} />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const FormContent = (props) => {

  const translate = useTranslate(); 
  
  let maxDocSvgSizeMin = maxDocSvgSize / 1000000;
  let labelInputFile = translate('docs.fieldSVG').replace('%size%',maxDocSvgSizeMin);
  
  return (
    <DialogContent>
        <Grid container spacing={2}>
            <Grid item xs={12}>   
                <TextInput fullWidth source="name" label={translate('tickets_maps.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
            </Grid> 
            { props.create ?
            <Grid item xs={12}>   
                <FileInput source="image" label={labelInputFile} accept="" validate={required()} maxSize={maxDocSvgSize} >
                    <FileField source="image" title="title" />
                </FileInput>
            </Grid>         
            : null }
        </Grid>           
    </DialogContent>
  );
  
};

const TicketsMapsEditButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
    
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [update, { loading, error }] = useUpdate();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'tickets_maps', 
        payload : { id: values.id, data : values }
      },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    

  return (
    <>
      <Tooltip title={translate('tickets_maps.edit')}>
        <span>
          <Button onClick={handleClick} label="" startIcon={<EditIcon />} title={translate('tickets_maps.edit')} aria-label={translate('tickets_maps.edit')} />
        </span>
      </Tooltip>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('tickets_maps.edit')}
        className="dialog-md"
        maxWidth="lg"
      >
        <DialogTitle>{translate('tickets_maps.edit')}</DialogTitle>

        <FormWithRedirect
          resource="tickets_maps"
          save={handleSubmit}
          initialValues={ props.record }
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <FormContent create={false} />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

